import React from 'react';
import classNames from 'classnames';
import './step-circles.css';

// Proptypes del styled component
const StepsCircle = (props) => {

  return (
  <div className={"StepContainer"}>
    <div className={"StepIndexPosition"}>
      <ol className={"StepsCircleDesign"}
      >
        {
            props.steps.map((step) => (
              <li className={classNames({ current: step.current }, { active: step.active })} key={step.title}>
                {
                  step.title && (
                  <div>
                    <p >{step.title}</p>
                  </div>
                  )
                }
              </li>
            ))
        }
      </ol>
    </div>
  </div>
  )
}

export default StepsCircle;
